<template>
    <v-app id="app">
        <!-- App bar -->
        <v-app-bar app clipped-right color="bal-gray" light flat>
            <v-app-bar-nav-icon large @click.stop="toggleDrawer" />
            <v-toolbar-title
                >{{ `${$route.meta.title}` | t
                }}<span style="color:gray;">{{ ` (${salesInvoicesCount})` }}</span></v-toolbar-title
            >
        </v-app-bar>

        <!-- Drawer left -->
        <main-drawer :drawer-open="mainDrawerOpen" @close="toggleDrawer" />

        <!-- Main content -->
        <v-main>
            <sales-invoices-view />
        </v-main>

        <!-- Footer -->
        <page-footer />
    </v-app>
</template>
<script>
import MainDrawer from "../components/main-drawer.vue";
import PageFooter from "../components/page-footer.vue";

import { mapGetters, mapState, mapMutations } from "vuex";
import Store from "../store";
import SalesInvoicesView from "../pages/sales-invoices/sales-invoices-view";

export default {
    components: {
        SalesInvoicesView,
        PageFooter,
        MainDrawer
    },
    data() {
        return {
            mainDrawerOpen: null
        };
    },
    mounted() {
        const drawerState = localStorage.getItem("mainDrawerOpen");
        if (drawerState) {
            this.mainDrawerOpen = JSON.parse(drawerState);
        } else {
            this.mainDrawerOpen = true;
        }
        /*if (this.user.role !== "admin") {
            this.$router.push({ name: "product-list" });
        }*/
    },
    methods: {
        toggleDrawer() {
            this.mainDrawerOpen = !this.mainDrawerOpen;
            localStorage.setItem("mainDrawerOpen", this.mainDrawerOpen);
        }
    },
    computed: {
        ...mapState("SalesInvoiceStore", ["drawerOpen"]),
        ...mapState(["user"]),
        ...mapGetters("SalesInvoiceStore", ["salesInvoicesCount"])
    }
};
</script>

<style>
.v-input__icon--prepend-inner .v-icon {
    margin-top: 0px !important;
}
</style>
